// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Bank } from './bank';
import { Practice } from './practice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PracticeBank extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  practiceBankId!: number;
  bankId!: number;
  createdBy!: string;
  createdDate!: Date;
  data?: string;
  data1?: string;
  data2?: string;
  flags?: number;
  practiceId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  bank!: Bank;
  practice!: Practice;
}

